export default function useDefaultTypesFromPrices(prices) {

    if (!prices) {
        return null;
    }   
    
    return [...new Set(prices.map(p => Object.keys(p).filter(t => !!p[t].default)).flat())];
}